import {
  ApplyInvoiceDiscountDTO,
  CreateSubscriptionDTO,
  IInvoiceItem,
  LoadType,
  ISubscription,
  IBaseListResponse,
  UpdateSubscriptionDTO,
  GetSubscriptionDTO
} from '@care-portals/api-interfaces';
import { createAction, props } from '@ngrx/store';

// get subscriptions
export const getSubscriptions = createAction(
  '[Subscription] Get Subscriptions',
  props<{ loadType: LoadType; params: GetSubscriptionDTO; supressNotification: boolean }>()
);
export const getSubscriptionsSuccess = createAction(
  '[Subscription] Get Subscriptions Success',
  props<{
    subscriptionResp: IBaseListResponse<ISubscription>;
    loadType: LoadType;
    filters: {
      limit: number;
      offset: number;
      sortKey: string;
      sortOrder: string;
    };
  }>()
);
export const getSubscriptionsFailure = createAction(
  '[Subscription] Get Subscriptions Failure',
  props<{ error: any }>()
);

export const getSubscription = createAction(
  '[Subscription] Get Subscription',
  props<{ subscriptionId: string }>()
);

export const clearSubscription = createAction(
  '[Subscription] Clear Subscription'
);

export const getSubscriptionSuccess = createAction(
  '[Subscription] Get Subscription Success',
  props<{ subscription: ISubscription }>()
);

export const getSubscriptionFailure = createAction(
  '[Subscription] Get Subscription Failure',
  props<{ error: any }>()
);

// cancel subscription
export const cancelSubscription = createAction(
  '[Subscription] Cancel Subscription',
  props<{ id: string }>()
);

export const cancelSubscriptionSuccess = createAction(
  '[Subscription] Cancel Subscription Success',
  props<{ subscription: ISubscription }>()
);
export const cancelSubscriptionFailure = createAction(
  '[Subscription] Cancel Subscription Failure',
  props<{ error: any }>()
);

// update subscription
export const updateSubscription = createAction(
  '[Subscriptions] Update Subscription',
  props<{ id: string; updates: UpdateSubscriptionDTO }>()
);

export const updateSubscriptionSuccess = createAction(
  '[Subscriptions] Update Subscription Success',
  props<{ subscription: ISubscription }>()
);

export const updateSubscriptionFailure = createAction(
  '[Subscriptions] Update Subscription Failure',
  props<{ error: any }>()
);

// discount
export const applyDiscountForInvoice = createAction(
  '[Subscription] Apply Discount For Subscription',
  props<{ req: ApplyInvoiceDiscountDTO }>()
);
export const applyDiscountForInvoiceSuccess = createAction(
  '[Subscription] Apply Discount For Subscription Success',
  props<{ discount: IInvoiceItem }>()
);
export const applyDiscountForInvoiceFailure = createAction(
  '[Subscription] Apply Discount For Subscription Failure',
  props<{ error: any }>()
);

export const openDiscountModal = createAction(
  '[Subscription] Open Discount Modal',
  props<{ subscription: ISubscription }>()
);

export const closeDiscountModal = createAction(
  '[Invoice] Close Discount Modal'
);

export const resetSubscriptions = createAction(
  '[Subscription] Reset Subscriptions'
);

export const openSubscriptionDetailsDrawer = createAction(
  '[Subscription] Open Subscription Details Drawer',
  props<{ subscriptionId: string; onClose?: () => void }>()
);

export const closeSubscriptionDetailsDrawer = createAction(
  '[Subscription] Close Subscription Details Drawer'
);

export const createSubscription = createAction(
  '[Subscription] Create Subscription',
  props<{ payload: Partial<CreateSubscriptionDTO> }>()
);

export const createSubscriptionSuccess = createAction(
  '[Subscription] Create Subscription Success',
  props<{ subscription: ISubscription }>()
);

export const createSubscriptionFailure = createAction(
  '[Subscription] Create Subscription Failure',
  props<{ error: any }>()
);

// export subscriptions
export const exportSubscriptions = createAction(
  '[Subscription] Export Subscriptions',
  props<{ dateRange: [Date, Date] }>()
);

export const exportSubscriptionsFailure = createAction(
  '[Subscription] Export Subscriptions Failure',
  props<{ error: any }>()
);

export const exportSubscriptionsSuccess = createAction(
  '[Subscription] Export Subscriptions Success',
  props<{ csvData: string }>()
);
